// Module
var code = "<div scrollable=\"130\" class=\"md-padding\">\n    <span ng-bind-html=\"page\"></span>\n</div>";
// Exports
module.exports = code;